import React, { useRef } from "react";

import "../Asociados/asociadosTable.css";

import { ImagePathBuilder } from "helper/tools";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { handleStatus } from "../../helperFunctions/helpers";
import { CiImageOn } from "react-icons/ci";
import BadgeStatus from "../Asociados/BadgeStatus";

/**
 *
 * @param {*} param0
 * @returns
 */

export default function ProveedoresTable({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <>
      <table
        className="table table-borderless datable sortable table-hover"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              scope="col"
              data-column="numProveedor"
              style={{ width: "100px" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>
            <th
              scope="col"
              data-column="nombre"
              onClick={(event) => handleSort(event)}
            >
              Nombre
            </th>

            <th
              scope="col"
              data-column="rfc"
              onClick={(event) => handleSort(event)}
              style={{ width: "150px" }}
            >
              RFC
            </th>

            <th
              scope="col"
              data-column="banco"
              onClick={(event) => handleSort(event)}
              style={{ width: "120px" }}
            >
              Banco
            </th>
            <th
              scope="col"
              data-column="cuenta"
              className="no-sort"
              onClick={(event) => handleSort(event)}
              style={{ width: "160px" }}
            >
              Cuenta
            </th>
            <th
              scope="col"
              data-column="correo"
              style={{ width: "140px" }}
              onClick={(event) => handleSort(event)}
            >
              Email
            </th>
            <th
              scope="col"
              data-column="telefono"
              style={{ width: "160px" }}
              onClick={(event) => handleSort(event)}
            >
              Telefono
            </th>

            <th
              scope="col"
              data-column="activo"
              style={{ width: "80px" }}
              onClick={(event) => handleSort(event)}
            >
              Estatus
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={8} rowCount={4} />}

          {!isLoading &&
            items?.length > 0 &&
            items?.map((item) => {
              return (
                <tr key={item.id}>
                  <th
                    scope="row"
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <div onClick={(e) => openItem(item)}>
                      {item.numProveedor ?? ""}
                    </div>
                  </th>
                  {/**  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.sku ?? ""}
                    </a>
                  </td>
                   */}
                  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.nombre ?? ""}
                    </a>
                  </td>
                  <td>{item.rfc ?? ""}</td>
                  <td>{item.banco ?? ""}</td>
                  <td>{item.numCuenta ?? ""}</td>
                  <td>{item.email ?? ""}</td>
                  <td>{item.telefono ?? ""}</td>

                  <BadgeStatus item={item} />
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
